import { marker } from '@colsen1991/ngx-translate-extract-marker';

export enum EDocumentType {
  TermsAndConditions = 'TERMS_AND_CONDITIONS',
  LicenseAgreement = 'LICENSE_AGREEMENT',
  UserAgreement = 'USER_AGREEMENT',
  TermsOfUse = 'TERMS_OF_USE',
  VenueRules = 'VENUE_RULES',
  EULA = 'EULA',
}

export enum EDocumentUser {
  BusinessOwner = 'BUSINESS_OWNER',
  Staff = 'STAFF',
  Gamer = 'GAMER',
}

export enum EDocumentStatus {
  Published = 'PUBLISHED',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
}

export enum EDocumentPublishMode {
  RequireSignature = 'REQUIRE_SIGNATURE',
  UpdateOnly = 'UPDATE_ONLY',
}

export enum EDocumentSource {
  GamerInterface = 'GAMER_INTERFACE',
  AdminInterface = 'ADMIN_INTERFACE',
  OWNER_PORTAL = 'OWNER_PORTAL',
  Mobile = 'MOBILE_APP',
  SenetId = 'SENET_ID',
}

export enum EDocumentOwnerType {
  Senet = 'SENET',
  Venue = 'VENUE',
}

export const I18N_DOCUMENT_TYPE_MAP = new Map<EDocumentType, string>([
  [EDocumentType.TermsAndConditions, marker('enums.document.type.terms-and-conditions')],
  [EDocumentType.LicenseAgreement, marker('enums.document.type.license-agreement')],
  [EDocumentType.UserAgreement, marker('enums.document.type.user-agreement')],
  [EDocumentType.TermsOfUse, marker('enums.document.type.terms-of-use')],
  [EDocumentType.VenueRules, marker('enums.document.type.venue-rules')],
  [EDocumentType.EULA, marker('enums.document.type.eula')],
]);

export const I18N_DOCUMENT_STATUS_MAP = new Map<EDocumentStatus, string>([
  [EDocumentStatus.Published, marker('enums.document.status.published')],
  [EDocumentStatus.Archived, marker('enums.document.status.archived')],
  [EDocumentStatus.Draft, marker('enums.document.status.draft')],
]);

export const I18N_DOCUMENT_SOURCE_MAP = new Map<EDocumentSource, string>([
  [EDocumentSource.AdminInterface, marker('enums.document.source.admin-interface')],
  [EDocumentSource.GamerInterface, marker('enums.document.source.gamer-interface')],
  [EDocumentSource.SenetId, marker('enums.document.source.senet-id')],
  [EDocumentSource.Mobile, marker('enums.document.source.mobile')],
]);

export const DOCUMENT_SOURCE_OPTIONS: { value: EDocumentSource; label: string }[] = [
  { value: EDocumentSource.GamerInterface, label: I18N_DOCUMENT_SOURCE_MAP.get(EDocumentSource.GamerInterface)! },
  { value: EDocumentSource.SenetId, label: I18N_DOCUMENT_SOURCE_MAP.get(EDocumentSource.SenetId)! },
  { value: EDocumentSource.Mobile, label: I18N_DOCUMENT_SOURCE_MAP.get(EDocumentSource.Mobile)! },
  { value: EDocumentSource.AdminInterface, label: I18N_DOCUMENT_SOURCE_MAP.get(EDocumentSource.AdminInterface)! },
];
